import { z } from "zod";

const publicEnvSchema = z.object({
  VITE_APP_ENV: z.enum(["local", "preview", "production"]),
  VITE_REALTIME_MODE: z.enum(["mock", "supabase", "offline"]),
  VITE_SUPABASE_URL: z.url().optional().or(z.literal("")),
  VITE_SUPABASE_ANON_KEY: z.string().optional(),
  VITE_POSTHOG_KEY: z.string().optional(),
  VITE_POSTHOG_HOST: z.url().optional().or(z.literal("")),
  VITE_SENTRY_DSN: z.url().optional().or(z.literal("")),
  VITE_STRIPE_PUBLISHABLE_KEY: z
    .string()
    .startsWith("pk_")
    .optional()
    .or(z.literal("")),
});

const parsed = publicEnvSchema.safeParse({
  ...import.meta.env,
  VITE_APP_ENV:
    import.meta.env.VITE_APP_ENV ??
    (import.meta.env.PROD ? "production" : "local"),
  VITE_REALTIME_MODE:
    import.meta.env.VITE_REALTIME_MODE ??
    (import.meta.env.PROD ? "offline" : "mock"),
});

if (!parsed.success) {
  throw new Error(
    `Invalid public environment: ${z.prettifyError(parsed.error)}`,
  );
}

if (
  parsed.data.VITE_APP_ENV === "production" &&
  parsed.data.VITE_REALTIME_MODE === "mock"
) {
  throw new Error("Mock traffic cannot run when VITE_APP_ENV=production.");
}

export const publicEnv = parsed.data;
